const features = [
  {
    id: "security",
    icon: "ri-shield-check-line",
    title: "Security & Privacy",
    description:
      "End-to-end encryption and zero-knowledge architecture ensure your data stays yours. We never collect, sell, or share personal information.",
    image:
      "https://public.readdy.ai/ai/img_res/8bb13eae46da6a5d0ef8f79640025a32.jpg",
  },
  {
    id: "performance",
    icon: "ri-speed-up-line",
    title: "Peak Performance",
    description:
      "Optimized for the latest Apple Silicon chips. Our apps are lightweight, battery-efficient, and blazing fast — even on older devices.",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20performance%20speed%20concept%20with%20glowing%20motion%20lines%20and%20energy%20waves%2C%20dark%20charcoal%20background%20with%20orange%20and%20white%20light%20streaks%2C%20minimalist%20tech%20art%2C%20no%20text%2C%20cinematic%20quality&width=500&height=650&seq=feature-performance-formo-001&orientation=portrait",
  },
  {
    id: "ux",
    icon: "ri-hand-heart-line",
    title: "Intuitive Design",
    description:
      "Every interaction is thoughtfully crafted following Apple&apos;s Human Interface Guidelines. Clean, accessible, and delightful to use every day.",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20user%20interface%20design%20concept%20with%20floating%20geometric%20UI%20elements%20and%20soft%20gradients%2C%20light%20background%20with%20subtle%20shadows%2C%20minimalist%20modern%20art%2C%20no%20text%2C%20premium%20quality&width=500&height=650&seq=feature-ux-formo-001&orientation=portrait",
  },
  {
    id: "updates",
    icon: "ri-refresh-line",
    title: "Regular Updates",
    description:
      "We ship continuous improvements, new features, and security patches. Our products evolve with iOS — always current, always reliable.",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20software%20update%20concept%20with%20circular%20arrows%20and%20glowing%20nodes%20on%20dark%20background%2C%20deep%20navy%20and%20white%20light%20accents%2C%20minimalist%20tech%20art%2C%20no%20text%2C%20cinematic%20quality&width=500&height=650&seq=feature-updates-formo-001&orientation=portrait",
  },
];

export default function FeaturesSection() {
  return (
    <section
      id="features"
      className="w-full py-28 md:py-36 px-6 md:px-12 lg:px-20"
      style={{ background: "linear-gradient(165deg, #F5F5F7 0%, #FAFAFA 100%)" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <div>
            <span className="block text-xs uppercase tracking-widest text-gray-400 font-medium mb-4">
              Platform Features
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
              Designed for the
              <br />
              iOS Ecosystem
            </h2>
          </div>
          <p className="text-base text-gray-400 max-w-xs md:text-right leading-relaxed">
            Every feature is purpose-built to integrate seamlessly with Apple&apos;s platform and your daily workflow.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <article
              key={feature.id}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
              style={{ height: 420 }}
            >
              {/* Background Image */}
              <img
                src={feature.image}
                alt={feature.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm mb-3">
                  <i className={`${feature.icon} text-white text-lg`} />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{feature.title}</h3>
                <p className="text-xs text-white/80 leading-relaxed">{feature.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
